import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";

export const usePostPatientEndTreatment = () => {
  const client = useApiClient();
  return useMutation<null, Error, number>(patientId => client.postPatientEndTreatment(patientId));
};
